<template>
	<div class="AppWowGraph">
		<div id="WowGraph" class="WowGraph" style="width: 100%;height: 300px;" />
		<!-- <div
      ref="wowGraph"
      style="width: 100%; height: 250px;"
    /> -->
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../mixins/graphData.js";
// import { Echarts } from "../../../../mixins/echarts.common.js";
// var echarts = require("../../../../node_modules/echarts/");
import { converters } from "../../../../mixins/converters";
// import IEcharts from "vue-echarts-v3/src/full.js";
export default {
	name: "AppWowGraph",
	// components: {IEcharts},
	mixins: [GraphData],
	data() {
		return {
			wowGraphInstance: null
		};
	},
	created() {
		// 	setTimeout(() => {
		// 		this.reRenderGraph();
		// 	}, 2000);
	},
	mounted() {
		this.showWowGraph();
		// this.initWowGraph();
	},
	methods: {
		// clearGraph: function() {
		// 	this.wowGraphInstance.clear();
		// },
		// reRenderGraph: function() {
		// 	// this.clearGraph();
		// 	console.log("this.wowGraph", this.graphData);

		// 	this.wowGraphInstance.setOption(this.graphData);
		// },
		// initWowGraph() {
		// 	// console.log("initOptions", this.initOptions);
		// 	let wowGraphContainer = this.$refs["wowGraph"];
		// 	this.wowGraphInstance = echarts.init(
		// 		wowGraphContainer,
		// 		null,
		// 		this.initOptions
		// 	);
		// 	// this.wowGraphInstance.showLoading();
		// },

		showWowGraph() {
			this.wowChart = echarts.init(document.getElementById("WowGraph"));
			var posList = [
				"left",
				"right",
				"top",
				"bottom",
				"inside",
				"insideTop",
				"insideLeft",
				"insideRight",
				"insideBottom",
				"insideTopLeft",
				"insideTopRight",
				"insideBottomLeft",
				"insideBottomRight"
			];

			app.configParameters = {
				rotate: {
					min: -90,
					max: 90
				},
				align: {
					options: {
						left: "left",
						center: "center",
						right: "right"
					}
				},
				verticalAlign: {
					options: {
						top: "top",
						middle: "middle",
						bottom: "bottom"
					}
				},
				position: {
					options: echarts.util.reduce(
						posList,
						function(map, pos) {
							map[pos] = pos;
							return map;
						},
						{}
					)
				},
				distance: {
					min: 0,
					max: 100
				}
			};

			app.config = {
				rotate: 90,
				align: "left",
				verticalAlign: "middle",
				position: "insideBottom",
				// distance: 15,
				onChange: function() {
					var labelOption = {
						normal: {
							rotate: app.config.rotate,
							align: app.config.align,
							verticalAlign: app.config.verticalAlign,
							position: app.config.position,
							distance: app.config.distance
						}
					};
					this.wowChart.setOption({
						textStyle: {
							color: "#838790"
						},
						series: [
							{
								label: labelOption
							},
							{
								label: labelOption
							},
							{
								label: labelOption
							},
							{
								label: labelOption
							}
						]
					});
				}
			};

			var labelOption = {
				normal: {
					show: true,
					position: app.config.position,
					distance: app.config.distance,
					align: app.config.align,
					verticalAlign: app.config.verticalAlign,
					rotate: app.config.rotate,
					formatter: "{c}  {name|{a}}",
					fontSize: 14,
					color: "#838790",
					rich: {
						name: {
							// textBorderColor: "#fff",
							color: "#838790",
							fontSize: 14
						}
					}
				}
			};

			this.wowChart.setOption({
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow"
					}
				},
				legend: {
					data: ["Sales", "Forecast", "Target", "%"]
				},
				// toolbox: {
				// 	show: true,
				// 	orient: "vertical",
				// 	left: "right",
				// 	top: "center",
				// 	feature: {
				// 		mark: { show: true },
				// 		dataView: { show: true, readOnly: false },
				// 		magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
				// 		restore: { show: true },
				// 		saveAsImage: { show: true }
				// 	}
				// },
				// calculable: true,
				xAxis: [
					{
						type: "category",
						axisTick: { show: false },
						data: []
					}
				],
				yAxis: [
					{
						type: "value",
						name: "lable",
						interval: 100,
						axisLabel: {
							formatter: "{value}"
						}
					},
					{
						type: "value",
						name: "lable",
						interval: 100,
						axisLabel: {
							formatter: "{value} %"
						}
					}
				],
				series: [
					{
						name: "Sales",
						type: "bar",
						barGap: 0.2,
						label: labelOption,
						data: [100, 200, 300, 400],
						itemStyle: {
							color: "#fcebea",
							borderColor: "#f9acaa"
						}
					},
					{
						name: "Forecast",
						type: "bar",
						barGap: 0.2,
						label: labelOption,
						data: [50, 150, 250, 350],
						itemStyle: {
							color: "#fff5eb",
							borderColor: "#fcd9b6"
						}
					},
					{
						name: "Target",
						type: "bar",
						barGap: 0.2,
						label: labelOption,
						yAxisIndex: 1,
						data: [150, 250, 350, 450],
						itemStyle: {
							color: "#e8fffe",
							borderColor: "#a0f0ed"
						}
					},
					{
						name: "%",
						type: "line",
						fontSize: 10,
						// barGap: 0.2,
						label: labelOption,
						yAxisIndex: 1,
						data: [10, 20, 30, 40],
						itemStyle: {
							color: "#f2d024",
							borderColor: "#a0f0ed"
						}
					}
				]
			});
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/variable.scss";
.AppWowGraph {
	background: #fff;
	border-radius: $app-border-radius;
	box-shadow: $app-card-shadow;
	margin: 0.5rem 0;
	padding: 1rem 0;
}
.AppWowGraph .WowGraph {
	height: 300px !important;
}
</style>
